import { UAParser } from 'ua-parser-js'
import { OSName } from 'ua-parser-js/enums'

const uaOS = new UAParser().getOS()

export const getIsIOS = () => uaOS.is(OSName.IOS)
export const getISAndroid = () => uaOS.is(OSName.ANDROID)

const getMajorVersion = async () => {
  try {
    const { version = '0' } = await uaOS.withClientHints()
    const [major] = version.split('.')

    return parseInt(major)
  } catch (exc) {
    console.error('Could get parse major version', exc)
    return null
  }
}

export const getAndroidVersion = () =>
  getISAndroid() ? getMajorVersion() : null
export const getIOSVersion = () => (getIsIOS() ? getMajorVersion() : null)
